export type PortalBranding = "visit-bergamo" | "default";

function toCanonicalPortalName(value: unknown): string {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, " ");
}

function toCompactPortalName(value: unknown): string {
  return toCanonicalPortalName(value).replace(/\s+/g, "");
}

export function normalizePortalName(value: unknown): string {
  return toCanonicalPortalName(value);
}

export function isTravelinPortal(value: unknown): boolean {
  const compact = toCompactPortalName(value);
  return compact === "travelin";
}

export function isVisitBergamoPortal(value: unknown): boolean {
  const compact = toCompactPortalName(value);
  return compact === "visitbergamo" || compact === "bergamo" || compact === "visitbergamotravelin";
}

export function getPriorityPortal(portals: unknown[]): string | null {
  const safePortals = Array.isArray(portals) ? portals : [];

  const travelin = safePortals.find((portal) => isTravelinPortal(portal));
  if (travelin != null) return String(travelin);

  const visit = safePortals.find((portal) => isVisitBergamoPortal(portal));
  if (visit != null) return String(visit);

  return safePortals.length > 0 ? String(safePortals[0]) : null;
}

export function getPortalBranding(portals: unknown[], fallbackIsVisit = false): PortalBranding {
  const priorityPortal = getPriorityPortal(portals);
  if (priorityPortal === null) return fallbackIsVisit ? "visit-bergamo" : "default";
  return isVisitBergamoPortal(priorityPortal) ? "visit-bergamo" : "default";
}
